/**
 * Get resume time from local storage, based on Resume ID
 * @export
 * @param {String} resumeID
 * @return {String} - Video time in seconds, or null if not found
 */
export function get_resume_time(resumeID) {
  try {
    const resumeTime = localStorage.getItem(resumeID);
    if (resumeTime) {
      return resumeTime - 3;
    } else {
      return null;
    }
  } catch (error) {
    console.error(`Error getting resume time: ${error}`);
    return null;
  }
}

/**
 * Set resume time in local storage, based on Resume ID
 * @export
 * @param {String} resumeID
 * @param {String} resumeTime - Video time in seconds
 * @return {Promise} - Resolves with void when the operation is complete
 */
export function set_resume_time(resumeID, resumeTime) {
  return new Promise((resolve, reject) => {
    try {
      localStorage.setItem(resumeID, resumeTime);
      resolve();
    } catch (error) {
      console.error(`Error setting resume time: ${error}`);
      reject(error);
    }
  });
}
